import { EditableProps, FieldEnum, Fields } from "@/lib/fields"
import { useSnapshot } from "valtio"
import { store } from "@/stores/stores"
import { JSX, useRef } from "react"
import { z } from "zod"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import FormField from "../FormField"
import { InputProps, InputSize } from "@/components/ui/input"
import { ButtonProps } from "@/components/ui/button"
import FormView from "../FormView"

interface FieldEditProps {
  onSubmit: (value: any) => Promise<any>
  onCancel?: () => void
  type?: FieldEnum
  modalKey?: string
  mode?: "modal" | "inline"
  title?: string
  children?: React.ReactNode
  editableProps?: Partial<EditableProps>
  confirmButtonProps?: Partial<ButtonProps>
  inputProps?: Partial<InputProps>
  getEditable?: (props: EditableProps) => JSX.Element
  before?: React.ReactNode
  zSchema?: z.ZodSchema
  disabled?: boolean
  // formProps
  initialValue?: any
}

export function FieldEdit(props: FieldEditProps) {
  const formViewRef = useRef(null)
  const snap = useSnapshot(store)

  const form = useForm({
    resolver: zodResolver(
      z.object({
        value: props.zSchema || z.any(),
      }),
    ),
    defaultValues: {
      value: props.initialValue,
    },
  })

  const fieldRecord = Fields.record[props.type || Fields.enum.Text]

  const onSubmit = async (values: { value: any }) => {
    let value = values.value

    // Upload avatar to AWS
    if (props.type === Fields.enum.Avatar && value !== null) {
      // TODO: Upload avatar to AWS
      // value = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7eCYJnsdKc-_6begYZ9tcnBDtL8zNDWASHA&s"
      // console.log("Uploading avatar to AWS", value)
      const uploaded = await store.app.actions.upload({ file: value })
      console.log("Uploaded avatar to AWS", uploaded)
      value = uploaded.publicUrl
    }

    return props.onSubmit(value)
  }

  const editableProps = {
    inputProps: { ...props.inputProps, size: "lg" as InputSize },
    onSubmit,
    form,
    ...props.editableProps,
  }

  const modalKey = props.modalKey || "field-edit"

  const editable = props.getEditable?.(editableProps) || (
    <FormField form={form} name="value">
      {fieldRecord.getEditable?.(editableProps)}
    </FormField>
  )

  return (
    <div
      onClick={() => {
        if (props.disabled) return

        store.app.actions.addModal(
          modalKey,
          <FormView
            trigger={props.children}
            ref={formViewRef}
            form={form}
            opened
            key={modalKey}
            onClose={() => {
              props.onCancel?.()
              store.app.actions.removeModal(modalKey)
            }}
            title={props.title || "Edit"}
            // onOpen={() => {
            //   form.reset({ value: props.initialValue })
            // }}
            onSubmit={onSubmit}
            // hideActions={props.type === Fields.enum.Avatar && snap.app.editingAvatar === false}
            hideActions={props.type === Fields.enum.Avatar}
            size={snap.app.editingAvatar ? "xl" : "sm"}
            destroyOnClose
            confirmButtonProps={props.confirmButtonProps}
          >
            {props.before}
            {editable}
          </FormView>,
        )
      }}
    >
      {props.children}
    </div>
  )

  // )
}
